import { internal, template } from '../../vendor/elix.js';
import WithSlotMixin from '../mixins/with-slot-mixin.js';

function TextFieldIconSlotsMixin(Base) {

  return class TextFieldIconSlots extends
    WithSlotMixin(
      WithSlotMixin(Base, 'trailing'),
    'leading'
    ) {

    getContainerToAnnotateWithClassName() {
      return this.shadowRoot.querySelector('.inputStateContainer')
    }

    getTemplateContainerToAppendSlotsTo(template) {
      return template.querySelector('.inputStateContainer');
    }

    get [internal.template]() {

      return template.concat(
        super[internal.template],
        template.html`

          <style>
            slot {
              display: block;
              font-size: 20px;
              position: absolute;
              top: var(--tp-text-field-icon-slot-top, 30px);
              transform: translateY(-50%);
            }

            slot[name=leading] {
              left: var(--tp-text-field-leading-icon-slot-left, 16px);
            }

            slot[name=trailing] {
              right: var(--tp-text-field-trailing-icon-slot-right, 16px);
            }

          </style>
        `
      );

    }

  }

}

export default TextFieldIconSlotsMixin;
